import { Ban } from "lucide-react";
import { useLocation } from "react-router-dom";

export const PolicyBanner = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith("/drivers-club") || loc.pathname.startsWith("/club") || loc.pathname.startsWith("/receipt")) return null;
  return (
    <div
      data-testid="policy-banner"
      className="fixed top-0 left-0 right-0 z-[70] h-9 flex items-center justify-center gap-2 px-4 bg-[#F2B705] text-black text-xs sm:text-sm font-semibold tracking-tight border-b border-black/20"
    >
      <Ban size={15} className="shrink-0" />
      <span className="text-center">
        <span className="font-extrabold uppercase">No out-of-town trips</span>
        <span className="hidden sm:inline"> — all rentals must stay within the St. Louis metro area.</span>
        <span className="sm:hidden"> — St. Louis metro only.</span>
      </span>
    </div>
  );
};
